import { Check, Copy, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useCopyToClipboard } from '@/shared/hooks/useCopyToClipboard';
import { cn } from '@/shared/lib/cn';

interface Props {
  value: string;
  /** Was kopiert wird, für den Vorleser: „Code Haustür“, „WLAN-Netz“, „Adresse“. */
  label: string;
  tone: 'dark' | 'light';
  className?: string;
}

/** Ein runder Kopierknopf mit 44 px — sagt, ob es geklappt hat, auch wenn der Browser ablehnt. */
export function CopyIconButton({ value, label, tone, className }: Props) {
  const { t } = useTranslation();
  const [copied, copy, failed] = useCopyToClipboard();
  const state = failed ? 'failed' : copied ? 'copied' : 'idle';
  return (
    <button
      type="button"
      onClick={() => void copy(value)}
      aria-label={t('travel.copy.idle', { label })}
      title={failed ? t('travel.copy.failed') : undefined}
      className={cn(
        'flex size-11 shrink-0 items-center justify-center rounded-full transition-colors',
        tone === 'dark'
          ? 'bg-white/15 text-white hover:bg-white/25'
          : 'border-line-strong text-fg hover:bg-bg-soft border',
        className,
      )}
    >
      {state === 'failed' ? (
        <X className="size-4" aria-hidden />
      ) : state === 'copied' ? (
        <Check className="size-4" aria-hidden />
      ) : (
        <Copy className="size-4" aria-hidden />
      )}
      <span className="sr-only" aria-live="polite">
        {state === 'idle' ? '' : t(`travel.copy.${state}`, { label })}
      </span>
    </button>
  );
}
